import PropTypes from 'prop-types';
import { meta } from '@happymoneyinc/meta';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const SvgIcon = props => {
  var _meta$icons$type, _meta$icons$type2, _meta$icons$type3, _meta$icons$type4, _meta$icons$type5, _meta$icons$type6, _meta$icons$type7, _meta$icons$type8, _meta$icons$type9, _meta$icons$type10;
  const {
    backgroundColor,
    className,
    fill,
    width,
    type,
    stroke,
    height,
    testID
  } = props;
  const initialHeight = meta === null || meta === void 0 ? void 0 : (_meta$icons$type = meta.icons[type]) === null || _meta$icons$type === void 0 ? void 0 : _meta$icons$type.height;
  const initialWidth = meta === null || meta === void 0 ? void 0 : (_meta$icons$type2 = meta.icons[type]) === null || _meta$icons$type2 === void 0 ? void 0 : _meta$icons$type2.width;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs("svg", {
      fill: "none",
      height: height || initialHeight,
      viewBox: `0 0 ${initialWidth} ${initialHeight}`,
      width: width || initialWidth,
      className: className,
      "data-testid": testID,
      children: [/*#__PURE__*/jsx("title", {
        children: meta === null || meta === void 0 ? void 0 : (_meta$icons$type3 = meta.icons[type]) === null || _meta$icons$type3 === void 0 ? void 0 : _meta$icons$type3.title
      }), (meta === null || meta === void 0 ? void 0 : (_meta$icons$type4 = meta.icons[type]) === null || _meta$icons$type4 === void 0 ? void 0 : _meta$icons$type4.rect) && (meta === null || meta === void 0 ? void 0 : (_meta$icons$type5 = meta.icons[type]) === null || _meta$icons$type5 === void 0 ? void 0 : _meta$icons$type5.rect.map((svgRect, index) => /*#__PURE__*/jsx("rect", {
        x: svgRect === null || svgRect === void 0 ? void 0 : svgRect.x,
        y: svgRect === null || svgRect === void 0 ? void 0 : svgRect.y,
        width: svgRect === null || svgRect === void 0 ? void 0 : svgRect.width,
        height: svgRect === null || svgRect === void 0 ? void 0 : svgRect.height,
        rx: svgRect === null || svgRect === void 0 ? void 0 : svgRect.rx,
        fill: (svgRect === null || svgRect === void 0 ? void 0 : svgRect.fill) || fill,
        stroke: svgRect === null || svgRect === void 0 ? void 0 : svgRect.stroke,
        opacity: svgRect === null || svgRect === void 0 ? void 0 : svgRect.opacity
      }, `${type + index}`))), (meta === null || meta === void 0 ? void 0 : (_meta$icons$type6 = meta.icons[type]) === null || _meta$icons$type6 === void 0 ? void 0 : _meta$icons$type6.circle) && (meta === null || meta === void 0 ? void 0 : (_meta$icons$type7 = meta.icons[type]) === null || _meta$icons$type7 === void 0 ? void 0 : _meta$icons$type7.circle.map((svgCircle, index) => /*#__PURE__*/jsx("circle", {
        cx: svgCircle === null || svgCircle === void 0 ? void 0 : svgCircle.cx,
        cy: svgCircle === null || svgCircle === void 0 ? void 0 : svgCircle.cy,
        fill: fill || svgCircle.fill,
        r: svgCircle === null || svgCircle === void 0 ? void 0 : svgCircle.r,
        opacity: svgCircle === null || svgCircle === void 0 ? void 0 : svgCircle.opacity
      }, `${type + index}`))), (meta === null || meta === void 0 ? void 0 : (_meta$icons$type8 = meta.icons[type]) === null || _meta$icons$type8 === void 0 ? void 0 : _meta$icons$type8.ellipse) && (meta === null || meta === void 0 ? void 0 : (_meta$icons$type9 = meta.icons[type]) === null || _meta$icons$type9 === void 0 ? void 0 : _meta$icons$type9.ellipse.map((svgEllipse, index) => /*#__PURE__*/jsx("ellipse", {
        cx: svgEllipse === null || svgEllipse === void 0 ? void 0 : svgEllipse.cx,
        cy: svgEllipse === null || svgEllipse === void 0 ? void 0 : svgEllipse.cy,
        rx: svgEllipse === null || svgEllipse === void 0 ? void 0 : svgEllipse.rx,
        ry: svgEllipse === null || svgEllipse === void 0 ? void 0 : svgEllipse.ry,
        fill: fill || svgEllipse.fill,
        r: svgEllipse === null || svgEllipse === void 0 ? void 0 : svgEllipse.r,
        opacity: svgEllipse === null || svgEllipse === void 0 ? void 0 : svgEllipse.opacity
      }, `${type + index}`))), meta === null || meta === void 0 ? void 0 : (_meta$icons$type10 = meta.icons[type]) === null || _meta$icons$type10 === void 0 ? void 0 : _meta$icons$type10.path.map((svgPath, index) => /*#__PURE__*/jsx("path", {
        d: svgPath.d,
        fill: `${backgroundColor || svgPath.backgroundColor ? backgroundColor || svgPath.backgroundColor : fill || svgPath.fill}`,
        stroke: stroke || svgPath.stroke,
        strokeWidth: svgPath === null || svgPath === void 0 ? void 0 : svgPath.strokeWidth,
        fillRule: svgPath === null || svgPath === void 0 ? void 0 : svgPath.fillRule,
        clipPath: svgPath === null || svgPath === void 0 ? void 0 : svgPath.clipPath,
        strokeLinecap: svgPath === null || svgPath === void 0 ? void 0 : svgPath.strokeLinecap,
        strokeLinejoin: svgPath === null || svgPath === void 0 ? void 0 : svgPath.strokeLinejoin
      }, `${type + index}`))]
    })
  });
};
SvgIcon.defaultProps = {
  backgroundColor: '',
  className: '',
  fill: '',
  height: '',
  stroke: '',
  testID: 'svg-icon',
  width: ''
};
SvgIcon.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  testID: PropTypes.string,
  type: PropTypes.string.isRequired,
  width: PropTypes.string
};
var SvgIcon$1 = SvgIcon;

export { SvgIcon$1 as default };
//# sourceMappingURL=SvgIcon.js.map
